import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';

import { getRetrieveVehicleKey } from '.';
import { vehicleService } from '../../../application/VehicleService';
import { DriversProject } from '../../../domain/driversProject/DriversProject';
import { Vehicle } from '../../../domain/vehicle/Vehicle';
import { useIsLogged } from '../../../hooks/session/useIsLogged';

export type UseRetrieveVehicleData =
  | {
      vehicle: Vehicle;
      project: DriversProject;
    }
  | undefined;

type UseRetrieveVehicleResponseProps = ServiceResponse<Function, UseRetrieveVehicleData>;

// Hooks act as 'Adapter' layer.
export const useRetrieveVehicle = (): UseRetrieveVehicleResponseProps => {
  const { isLogged } = useIsLogged();

  const { data, isError, isLoading, isSuccess, refetch } = useQuery(
    getRetrieveVehicleKey(),
    () => vehicleService.getVehicle(),
    {
      retry: 1,
      enabled: Boolean(isLogged),
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    data: data
      ? {
          vehicle: data.vehicle,
          project: data.project,
        }
      : undefined,
    run: refetch,
  };
};
